export default __webpack_public_path__ + "static/media/create-event-warning.ec15be23.svg";